import { useMediaQuery } from "./useMediaQuery";

/**
 * Tracks `prefers-reduced-motion: reduce` for respecting OS accessibility settings.
 */
export function usePrefersReducedMotion(): boolean {
  return useMediaQuery("(prefers-reduced-motion: reduce)");
}
